Object.keys(errors).forEach(function (key) {
    toastr.error(errors[key]);
});

if(success != ''){
    toastr.success(success);
}

axios.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
}, function (error) {
    if(error.response.data.message != undefined && error.response.data.errors == undefined){
        toastr.error(error.response.data.message);
    }

    if(error.response.data.errors != undefined){
        Object.entries(error.response.data.errors).forEach(function(item){
            item[1].forEach(function(item){
                toastr.error(item);
            })
        });
    }

    return Promise.reject(error);
});
